<template>
  <div>
    <table
      style="border:1px solid #e5e5e5;"
      v-if="jsonModel"
      class="uk-table uk-table-hover uk-table-middle uk-table-divider"
    >
      <thead>
        <tr>
          <th>Key</th>
          <th>Value</th>
          <th>
            Reset
            <vk-icon icon="refresh" @click="resetItem()"></vk-icon>
          </th>
        </tr>
      </thead>
      <tr v-for="jData in jsonModel">
        <th class="nopgmr">
          <input type="text" v-model="jData.key" class="uk-input" />:
        </th>
        <td class="nopgmr">
          <input type="text" v-model="jData.val" class="uk-input" />
        </td>
        <td class="nopgmr">
          <vk-icon
            icon="close"
            style="color:red"
            @click="deleteItem(jData)"
          ></vk-icon>
        </td>
      </tr>
      <tr>
        <td colspan="2"></td>
        <td class="nopgmr">
          <vk-icon icon="plus" @click="addItem()" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "json",
  data() {
    return {
      editForm: null,
      model: [],
      jsonModel: []
    };
  },
  props: ["input", "form", "value"],
  created() {
    this.loadItem();
  },
  methods: {
    loadItem() {
      this.model = this.value;
      this.jsonModel = [];
      Object.entries(Object.assign({}, JSON.parse(this.value))).forEach(
        element => {
          this.jsonModel.push({
            key: element[0],
            val: element[1]
          });
        }
      );
    },
    resetItem() {
      this.jsonModel = [];
      Object.entries(Object.assign({}, JSON.parse(this.model))).forEach(
        element => {
          this.jsonModel.push({
            key: element[0],
            val: element[1]
          });
        }
      );
    },
    deleteItem(item) {
      this.jsonModel.splice(this.jsonModel.indexOf(item), 1);
    },
    addItem() {
      this.jsonModel.push({ key: "", val: "" });
    }
  },
  watch: {
    jsonModel: {
      deep: true,

      handler() {
        let returnJson = [];
        this.jsonModel.forEach(elem => {
          returnJson[elem.key] = elem.val;
        });

        this.$parent.$emit("changed", {
          name: this.input.name,
          value: JSON.stringify(Object.assign({}, returnJson))
        });
      }
    }
  }
};
</script>

<style>
.nopgmr {
  margin: 0px !important;
  padding: 2px !important;
  align-items: center;
  text-align: center;
}
.nopgmr input {
  border: none !important;
  box-shadow: none;
  background: none;
}
th.nopgmr {
  background: #eee;
}
</style>
